import React from 'react';
import { connect } from "react-redux";
import pdfImage from '../../assets/pdf.png';

/**
 *
 * @param {*} param0
 */
const PhotoGrid = ({ photos, onPressImage }) => {
    const styles = {
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
        },
        image: {
            alignSelf: 'center',
            backgroundColor: 'transparent',
            height: 200,
            width: 'auto',
            marginTop: 10
        }
    };

    return (
        <div style={styles.container}>
            {photos.map((photo, i) => {
                const isPDF = photo.file.type === 'application/pdf';

                if (onPressImage) {
                    if (isPDF) {
                        return (
                            <img
                                alt="Receipt"
                                src={pdfImage}
                                style={styles.image}
                                onClick={() => onPressImage(i)}
                            />
                        );
                    }

                    return (
                        <img
                            alt="Receipt"
                            src={photo.image}
                            style={styles.image}
                            onClick={() => onPressImage(i)}
                        />
                    );
                }

                if (isPDF) {
                    return (
                        <img alt="Receipt" src={pdfImage} style={styles.image} />
                    );
                }

                return (
                    <img alt="Receipt" src={photo.image} style={styles.image} />
                );
            })}
        </div>
    );
};

export default connect()(PhotoGrid);